import { render, staticRenderFns } from "./map-products.vue?vue&type=template&id=3723fa64&scoped=true&"
import script from "./map-products.vue?vue&type=script&lang=js&"
export * from "./map-products.vue?vue&type=script&lang=js&"
import style0 from "./map-products.vue?vue&type=style&index=0&id=3723fa64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3723fa64",
  null
  
)

export default component.exports